module.exports = __webpack_public_path__ + "static/media/DH_04.74026e65.jpg";